import React from 'react';
import ResultItem from '../resultItem';

export default class HeaderSearchResultsCategory extends React.Component {
  static propTypes = {
    isMobile:   React.PropTypes.bool,
    results:    React.PropTypes.array,
    searchTerm: React.PropTypes.string,
    category:   React.PropTypes.string
  };

  limit = 12; // The largest amount of items to ever display in one category

  renderLinks = () => {
    return this.props.results.slice(0, this.limit).map(function (result, index) {
      return <ResultItem {...result} key={index} searchTerm={this.props.searchTerm} />;
    }, this);
  };

  render () {
    const containerClass = 'header__searchresults__group';

    return (
      <div className={containerClass} data-component="header-searchresults-group">
        <h3
          className="header__searchresults__group__heading"
          data-component="header-searchresults-groupheading">
          {this.props.category}
        </h3>
        <ul className="header__searchresults__group__results">
          {this.renderLinks()}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/searchresults/resultCategory/index.js